import $ from 'jquery';

export const listenForImagesTagSearchEmpty = () => {
  $('body').on(
    'mouseup',
    '#input-ricerca-immagini,#input-ricerca-manifesti',
    (event) => {
      const input = $(event.currentTarget);
      const oldValue = input.val();

      if (!oldValue) {
        return;
      }

      // When this event is fired after clicking on the clear button
      // the value is not cleared yet. We have to wait for it.
      setTimeout(() => {
        const newValue = input.val();

        if (newValue === '') {
          input.trigger('cleared');
        }
      }, 1);
    }
  );
};
